<template>
  <div v-if="hasFiles">
    <ContractFormFilesListItem
      v-for="(file, i) in files"
      :key="i"
      :file="file"
      :edit-mode="edit"
      :file-path="
        contractId ? `/contracts/${contractId}/files/${file.storage_name}` : `/files/${file.id}`
      "
      :is-viewing-as-company="isViewingAsCompany"
      :needs-review="needsReview"
      :show-changes="showChanges"
      @toggle-file-deletion="toggleFileDeletion(i)"
    />

    <WdsButtonText type="button" @click="downloadAll">
      {{ $t('Download all files') }}
    </WdsButtonText>
  </div>
</template>

<script>
import { WdsButtonText } from '@worksome/wds-components'
import ContractFormFilesListItem from '@/components/ContractFormFilesListItem.vue'

export default {
  components: {
    ContractFormFilesListItem,
    WdsButtonText,
  },

  props: {
    files: { type: Array, default: () => [] },
    // eslint-disable-next-line vue/no-boolean-default -- Baseline eslint ignore please fix if working on this
    isViewingAsCompany: { type: Boolean, default: true },
    needsReview: { type: Boolean, default: false },
    edit: { type: Boolean, default: false },
    contractId: { type: Number, required: true },
    showChanges: { type: Boolean, default: false },
  },
  computed: {
    hasFiles() {
      return this.files.length > 0
    },
  },
  methods: {
    toggleFileDeletion(id) {
      this.$emit('toggleFileDeletion', id)
    },
    downloadAll() {
      this.files.forEach((f) => {
        // eslint-disable-next-line no-param-reassign
        f.isReviewed = true
      })
      document.getElementsByClassName('contract-form-file-link').forEach((link) => {
        link.click()
      })
    },
  },
}
</script>
